<!-- 薪资发放 -->
<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="单位名称">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.companyId">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="结算类型">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.type">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="劳务班组">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.teamId">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="(item,key) in teamMap" :key="key" :value="item.id">{{item.teamName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="人员姓名" >
                    <a-input class="search-input" placeholder="请输入" v-model="searchInfo.personnelName" />
                </a-form-item>

                <a-form-item>
                    <a-input-group compact>
                        <a-select style="width: 60px;margin-right:2px" v-model="dataType" @change="changeDateType">
                            <a-select-option :value="1">年</a-select-option>
                            <a-select-option :value="2">月</a-select-option>
                        </a-select>
                        <a-date-picker v-if="dataType == 1" mode="year" v-model="searchInfo.payYear" format='YYYY' :open="yearShowOne" @openChange="openChangeOne" @panelChange="panelChangeOne" class="search-select" />
                        <a-month-picker v-else v-model="searchInfo.payMonth" format='YYYY-MM' class="search-select" />
                    </a-input-group>
                    
                </a-form-item>


                <a-form-item>
                    <a-button type="primary" class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                </a-form-item>
            </a-form>
            <a-row class="right-action-panel m-t-14">
                <a-row class="total-data-wrap">
                    <a-col class="item">
                        <span class="key">人员数量：</span>
                        <span class="val">{{totalStatistics.personCount || 0}}</span>
                    </a-col>
                    <a-col class="item">
                        <span class="key">工作总天数(天)：</span>
                        <span class="val">{{totalStatistics.workDay || 0}}</span>
                    </a-col>
                    <a-col class="item">
                        <span class="key">总工时(时)：</span>
                        <span class="val">{{totalStatistics.workTime || 0}}</span>
                    </a-col>
                    <a-col class="item">
                        <span class="key">工资合计(元)：</span>
                        <span class="val">{{totalStatistics.totalSalary || 0}}</span>
                    </a-col>
                </a-row>
                <a-button type="primary" @click="showTypeModal" class="item">生成工资表</a-button>
                <a-button class="item" @click="exprotFile('companyPaySalaryPersonnelExprot',{params:searchInfo,dateFormat:(dataType == 1 ? 'YYYY' :'MM')})"><a-icon type="export" />导出</a-button>
            </a-row>
        </section>
        <section class="list-table-container m-t-10">
             
            <a-table size="small" :columns="columns" :data-source="listData" :pagination="{total,hideOnSinglePage:true,pageSize,showTotal:(total) => `共${total}条`,size:'default',showQuickJumper:true,showSizeChanger:false}" @change="changePageNum"></a-table>
        </section>

        
        <!-- modal -->
        <a-modal centered width="660px" class="modal-container" :title="typeModal.title" v-model="typeModal.visible" :footer="false" :destroyOnClose="true">
            
          <a-row :gutter="16" class="type-modal" style="margin:40px 0">
              <a-col :span="8" v-for="item in payObjectLists" :key="item.id">
                  <a-row class="type-list" >
                      <div class="icon-wrap" @click="selectType(item.id)">
                           <img :src="item.icon" alt="">
                      </div>
                      <div>
                          <a>{{item.name}}</a>
                      </div>
                  </a-row>
              </a-col>
          </a-row>

        </a-modal>

        <a-modal centered :width="actionModal.width" class="modal-container" :title="actionModal.title" v-model="actionModal.visible" :footer="false" :destroyOnClose="true">
            <a-form :form="form">
               <a-form-item :label-col="{span:4}" :wrapper-col="{span:18}" label="单位名称" v-if="payType == 2 || payType == 1">
                   <a-select placeholder="请选择" v-decorator="['companyId',{rules:[{required:true,message:'请选择单位'}]}]">
                       <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                   </a-select>
               </a-form-item>
               <a-form-item :label-col="{span:4}" :wrapper-col="{span:18}" label="班组名称" v-if="payType == 2">
                   <a-select placeholder="请选择" v-decorator="['teamId',{rules:[{required:true,message:'请选择班组'}]}]">
                       <a-select-option v-for="(item,key) in teamMap" :key="key" :value="item.id">{{item.teamName}}</a-select-option>
                   </a-select>
               </a-form-item>
               <a-form-item :label-col="{span:4}" :wrapper-col="{span:18}" label="年月">
                   <a-month-picker placeholder="请选择" v-decorator="['payMonth',{rules:[{required:true,message:'请选择年月'}]}]" />
               </a-form-item>
               <a-form-item :label-col="{span:4}" :wrapper-col="{span:18}" label="结算类型">
                   <a-select placeholder="请选择" v-decorator="['type',{rules:[{required:true,message:'请选择结算类型'}]}]">
                       <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                   </a-select>
               </a-form-item>
               <a-form-item :label-col="{span:4}"  :wrapper-col="{span:18}" label="选择人员" v-if="payType == 3">
                   <a-button type="primary" v-decorator="['personnelIds',{rules:[{required:true,message:'请选择结算类型'}]}]" size="small" @click="showSelectpersonnelModal"><a-icon type="setting" />配置人员</a-button>
                   <section class="list-table-container m-t-18" v-if="personnelLists.length">
                       <a-table size="small" :columns="personColumns" :data-source="personnelLists" :pagination="{total:personnelLists.length,hideOnSinglePage:true}">
                        <a slot="action" slot-scope="text,list">
                            <a-popconfirm title="确定删除该培训人员?" @confirm="deletePerson(list.id)">删除</a-popconfirm>
                        </a>
                    </a-table>
                   </section>
               </a-form-item>
               <a-row class="form-btn-group">
                    <a-button class="btn-save" @click="submit"><a-icon type="save" />生成</a-button>
                    <a-button class="btn-cancel"  @click="actionModal.visible = false">取消</a-button>
                </a-row>
           </a-form>

           
        </a-modal>
        <a-modal width="1080px" class="modal-container" v-model="selectPersonModal.visible" title="人员列表" :footer="false" :destroyOnClose="true" >
            <selectPerson @ok="getSelectPerson" @cancel="selectPersonModal.visible = false" />
        </a-modal>

        <!-- <a-modal>
            <selectPerson @ok="selectPersonSubmit" @cancel="actionModal.visible = false" />
        </a-modal> -->
    </section>
</template>

<script>
const personColumns =[
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'所属单位',dataIndex:'companyName',align:'center',key:'companyName'},
    {title:'姓名',dataIndex:'personnelName',align:'center',key:'personnelName'},
    {title:'电话号码',dataIndex:'phoneNumber',align:'center',key:'phoneNumber'},
    {title:'职务/工种',dataIndex:'jobName',align:'center',key:'jobName'},
    {title:'操作',scopedSlots:{customRender: "action"},align:'center'},
]
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key',},
    {title:'年份',dataIndex:'payYear',align:'center',key:'payYear'},
    {title:'月份',dataIndex:'payMonth',align:'center',key:'payMonth'},
    {title:'姓名',dataIndex:'personnelName',align:'center',key:'personnelName'},
    {title:'身份证号',dataIndex:'idCard',align:'center',key:'idCard'},
    {title:'单位名称',dataIndex:'companyName',align:'center',key:'companyName'},
    {title:'劳务班组',dataIndex:'teamName',align:'center',key:'teamName'},
    {title:'结算类型',dataIndex:'typeName',align:'center',key:'typeName'},
    {title:'天数',dataIndex:'workDay',align:'center',key:'workDay'},
    {title:'工时',dataIndex:'workTime',align:'center',key:'workTime'},
    {title:'加班工时',dataIndex:'overTime',align:'center',key:'overTime'},
    {title:'加班工资(元)',dataIndex:'overtimeSalary',align:'center',key:'overtimeSalary'},
    {title:'工资合计(元)',dataIndex:'totalSalary',align:'center',key:'totalSalary'},
    {title:'开户行',dataIndex:'payBankname',align:'center',key:'payBankname'},
    {title:'银行卡号',dataIndex:'payCardnum',align:'center',key:'payCardnum'}
]
import selectPerson from '@/components/selectPerson'
import {exprotFile} from '@/until/unit'
export default {
    data(){
        return{
            columns,
            total:0,
            pageSize:10,
            pageNum:1,
            listData:[],
            companyMap:[],
            teamMap:[],
            searchInfo:{
                payMonth:null,
                payYear:null
            },
            typeModal:{
                visible:false,
                title:'选择'
            },
            payObjectLists:[
                {name:'按单位生成',id:1,icon:require('../../../../assets/image/icon/company.png')},
                {name:'按班组生成',id:2,icon:require('../../../../assets/image/icon/team.png')},
                {name:'按人员生成',id:3,icon:require('../../../../assets/image/icon/personnel.png')}
            ],
            
            payType:'',     //结算对象类型

            typeList:[],
            
            actionModal:{
                visible:false,
                title:'操作',
                width:600
            },
            selectPersonModal:{
                visible:false,
                title:'人员选择'
            },
            personColumns,
            personnelLists:[],
            yearShowOne:false,
            dataType:1,
            totalStatistics:{}
        }
    },
    components:{selectPerson},
    beforeCreate(){
        this.form = this.$form.createForm(this)
    },
    created(){
       this.init() 
    },
    mounted(){
        
        this.queryCompanyPaySalaryPersonnelList()
        this.queryCompanyPaySalaryPersonnelStatistics()
    },
    methods:{
        exprotFile,
        openChangeOne(status){
            if(status){
                this.yearShowOne =  true
            }
        },
        panelChangeOne(value){
            this.searchInfo.payYear = value
            this.yearShowOne = false
        },
        changeDateType(){
            this.searchInfo.payYear = this.dataType == 1 ? this.searchInfo.payYear : null
            this.searchInfo.payMonth = this.dataType == 2 ? this.searchInfo.payMonth : null
        },
        init(){
            this.queryCompanyDropDownBox()
            this.queryTeamDropDownBox()
            this.queryCompanyPayTypeList()
        },
        showTypeModal(){
            this.typeModal.visible = true
        },
        selectType(type){
            this.payType = type
            this.typeModal.visible = false
            this.actionModal.width = (type == 1 || type == 2) ? 600 : 880
            this.actionModal.visible = true
        },
        //结算类型下拉
        queryCompanyPayTypeList(){
            this.$api.queryCompanyPayTypeList({size:1000}).then(res =>{
                if(res.code === 200){
                    this.typeList = (res.data && res.data.records) || []
                }
            })
        },
        //单位下拉
        queryCompanyDropDownBox(){
            this.$api.queryCompanyDropDownBox().then(res =>{
                if(res.code === 200){
                    this.companyMap = res.data || []
                }
            })
        },
        //班组下拉
        queryTeamDropDownBox(){
            this.$api.queryTeamDropDownBox().then(res =>{
                if(res.code === 200){
                    this.teamMap = res.data || []
                }
            })
        },
        queryCompanyPaySalaryPersonnelStatistics(){
            this.$api.queryCompanyPaySalaryPersonnelStatistics().then(res =>{
                if(res.code === 200){
                    this.totalStatistics = res.data || {}
                }
            })
        },
        //查询薪资统计列表
        queryCompanyPaySalaryPersonnelList(){
            let params = {...this.searchInfo}
            params.current = this.pageNum
            params.size = this.pageSize
            params.payYear = this.searchInfo.payYear ? this.searchInfo.payYear.format('YYYY') : ''
            params.payMonth = this.searchInfo.payMonth ? this.searchInfo.payMonth.format('MM') : ''
            this.$api.queryCompanyPaySalaryPersonnelList(params).then(res =>{
                if(res.code === 200){
                    this.listData = (res.data && res.data.records) || []
                    this.total = (res.data && res.data.total) || 0
                    this.listData.forEach((item,ind) =>{
                        item.key = (this.pageSize*(this.pageNum - 1))+ind+1
                    })
                }
            })
        },
        reset(){
            this.searchInfo = {
                payYear:null,
                payMonth:null
            }
            this.pageNum = 1
            this.queryCompanyPaySalaryPersonnelList()
        },
        search(){
            this.pageNum = 1
            this.queryCompanyPaySalaryPersonnelList()
        },
        changePageNum(p){
            this.pageNum = p.current
            this.queryCompanyPaySalaryPersonnelList()
        },
        showSelectpersonnelModal(){
            this.selectPersonModal.visible = true
        },
        getSelectPerson(list){
            list.forEach((item,ind) =>{
                item.key = ind+1
            })
            this.personnelLists = list
            this.selectPersonModal.visible = false
            this.backfillPersonForm()
        },
        deletePerson(id){
            this.personnelLists = this.personnelLists.filter(item => item.id !== id)
            this.backfillPersonForm()
        },
        backfillPersonForm(){
            this.$nextTick(() =>{
                this.form.setFieldsValue({
                    personnelIds:this.personnelLists.length ? this.personnelLists.map(item => item.id) : ''
                })
            })
        },

        submit(){
            this.form.validateFields((err,formData) =>{
                if(!err){
                    let params = {...formData}
                    params.payYear = formData.payMonth.format('YYYY')
                    params.payMonth = Number(formData.payMonth.format('M'))
                    params.payType = this.payType
                    
                    this.$api.salaryTotalPayment(params).then(res =>{
                        if(res.code === 200){
                            this.actionModal.visible = false
                            this.personnelLists = []
                        }
                    })
                }
            })
        }

    }
}
</script>

<style lang="scss" scoped>
    .type-modal{
        .type-list{
            text-align: center;
            cursor: pointer;
            .icon-wrap{
                display: inline-block;
                width: 120px;
                height: 120px;
                line-height: 120px;
                border:1px dotted rgba(255,255,255,0.2);
                border-radius: 4px;
                margin-bottom: 8px;
                img{
                    width:66px;
                    opacity: 0.8;
                }
            }
        }
    }
</style>